import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import TranslatedString from "Components/TranslatedString";
const password = require("secure-random-password");

export default class PasswordGenerator extends React.Component {
  constructor() {
    super();
    this.state = {
      generated: null,
      copied: false,
      forceCiao1234:
        process.env.NODE_ENV && process.env.NODE_ENV !== "production" && !window.location.hostname.match(/sandbox/),
    };
  }

  generateStrongPassword() {
    return password.randomPassword({ characters: [password.lower, password.upper, password.digits] });
  }

  generateRandomPassword() {
    const { onNewPassword } = this.props;

    let newPassword;

    if (this.state.forceCiao1234) {
      newPassword = "Ciao1234";
    } else {
      newPassword = this.generateStrongPassword();
    }

    this.setState({ generated: newPassword, copied: false });

    if (onNewPassword) {
      onNewPassword(newPassword);
    }
  }

  renderCopyButton() {
    return (
      <span>
        <CopyToClipboard text={this.state.generated || ""} onCopy={() => this.setState({ copied: true })}>
          <a>{!this.state.copied && <TranslatedString>action.copy</TranslatedString>}</a>
        </CopyToClipboard>
        {this.state.copied ? (
          <span style={{ color: "green" }}>
            <TranslatedString>action.copied.password</TranslatedString>
          </span>
        ) : null}
      </span>
    );
  }

  render() {
    const { className } = this.props;
    return (
      <div
        className={className}
        style={{
          fontSize: "0.875rem",
          fontWeight: "400",
          lineHeight: "2rem",
          textAlign: "left",
          display: "flex",
          alignItems: "flex-center",
        }}
      >
        <a onClick={this.generateRandomPassword.bind(this)}>
          <TranslatedString>
            {this.state.generated ? "action.generateNewPassword" : "action.generateRandomPassword"}
          </TranslatedString>
        </a>
        {this.state.generated && (
          <span
            style={{
              borderLeft: "1px solid #ebebeb",
              padding: "0 0 0 0.5rem",
              margin: "0 0 0 0.5rem",
            }}
          >
            <span
              style={{
                letterSpacing: "0.01em",
                background: "#f8f8f8",
                padding: "0.25rem 0.5rem",
              }}
            >
              {this.state.generated}
            </span>
            {this.state.generated && <span> - {this.renderCopyButton()}</span>}
          </span>
        )}
      </div>
    );
  }
}
